export const COURSE_TYPE_ALL_TYPES = 'ALL_TYPES';

export enum CourseType {
  LIVE_CLASS = 'LIVE_CLASS',
  PRIVATE_CLASS = 'PRIVATE_CLASS',
  PRACTICE = 'PRACTICE',
  LESSON = 'LESSON',
  UNIT_ASSESSMENT = 'UNIT_ASSESSMENT',
  LEVEL_ASSESSMENT = 'LEVEL_ASSESSMENT',
  NEWS = 'NEWS',
  LEVEL_ZERO = 'LEVEL_ZERO',
  IDIOMS = 'IDIOMS',
}
